"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4430],{

/***/ 64430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ view_DesktopMegaMenu; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/view/DesktopMegaMenu/DesktopMegaMenuContainer.js



function DesktopMegaMenuContainer(param) {
    var isActive = param.isActive, onMenuHover = param.onMenuHover, children = param.children;
    var ref = (0,react.useRef)(null);
    var handleMouseOver = function() {
        return onMenuHover(true);
    };
    var handleMouseOut = function() {
        return onMenuHover(false);
    };
    (0,react.useEffect)(function() {
        var node = ref.current;
        if (node) {
            node.addEventListener("mouseenter", handleMouseOver);
            node.addEventListener("mouseleave", handleMouseOut);
            return function() {
                node.removeEventListener("mouseenter", handleMouseOver);
                node.removeEventListener("mouseleave", handleMouseOut);
            };
        }
    }, [
        ref.current
    ] // Recall only if ref changes
    );
    if (isActive === false) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative w-full",
        ref: ref,
        children: children
    });
};
DesktopMegaMenuContainer.defaultProps = {
    isActive: false,
    onMenuHover: function() {
        return null;
    }
};
DesktopMegaMenuContainer.propTypes = {
    isActive: (prop_types_default()).bool,
    onMenuHover: (prop_types_default()).func,
    children: (prop_types_default()).node.isRequired
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
// EXTERNAL MODULE: ./src/components/ListItem/index.js + 1 modules
var ListItem = __webpack_require__(69505);
// EXTERNAL MODULE: ./src/components/UnorderedList/index.js + 1 modules
var UnorderedList = __webpack_require__(25747);
;// CONCATENATED MODULE: ./src/view/MainMenu/MenuQuicklinks.js




function MenuQuicklinksIsNew() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "inline-flex rounded-full bg-yellow-100 px-2 py-1 text-sm font-semibold uppercase leading-4 tracking-wider text-yellow-800 lg:text-xs",
        children: "Nuevo"
    });
}
function MenuQuicklinks() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnorderedList/* default */.Z, {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                className: "py-px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                    href: "/certificaciones",
                    className: "flex items-center space-x-2 rounded-full px-4 py-2 text-gray-600 hover:bg-white hover:text-gray-900 hover:shadow",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: "h-6 w-6 text-gray-300",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                d: "M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                                clipRule: "evenodd"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-medium",
                            children: "Certificaciones"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                className: "py-px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                    href: "/entrenamientos",
                    className: "flex items-center space-x-2 rounded-full px-4 py-2 text-gray-600 hover:bg-white hover:text-gray-900 hover:shadow",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: "h-6 w-6 text-gray-300",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-medium",
                            children: "Cursos de entrenamiento"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                className: "py-px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                    href: "https://socios.aibes.org/",
                    className: "flex items-center space-x-2 rounded-full px-4 py-2 text-gray-600 hover:bg-white hover:text-gray-900 hover:shadow",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: "mb-1 h-6 w-6 text-gray-300",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-medium",
                            children: "Portal de socios"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuQuicklinksIsNew, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                className: "py-px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                    href: "/entrenadores",
                    className: "flex items-center space-x-2 rounded-full px-4 py-2 text-gray-600 hover:bg-white hover:text-gray-900 hover:shadow",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: "h-6 w-6 text-gray-300",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-medium",
                            children: "Entrenadores"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/view/MainMenu/MenuCommon.js


function MenuCommon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "space-y-4 lg:py-4 lg:px-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuQuicklinks, {})
    });
};

;// CONCATENATED MODULE: ./src/view/DesktopMegaMenu/DesktopMegaMenuContent.js




function DesktopMegaMenuContent(param) {
    var rightContent = param.rightContent, bottomContent = param.bottomContent, children = param.children;
    var hasBottomContent = bottomContent !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-full flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                        className: "relative z-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "overflow-hidden bg-white xl:grid xl:grid-cols-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lg:py-10 xl:col-span-8 xl:py-12 xl:pr-10",
                                    children: children
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden xl:col-span-4 xl:flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex w-full bg-gray-100 lg:rounded lg:px-4 lg:py-5",
                                        children: rightContent || /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuCommon, {})
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-0 top-0 bottom-0 z-0 w-2/4 bg-white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute right-0 top-0 bottom-0 z-0 hidden w-2/4 bg-gray-100 xl:block"
                    })
                ]
            }),
            hasBottomContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-20 border-t bg-gradient-to-r from-green-50 via-green-100 to-white"
            })
        ]
    });
};
DesktopMegaMenuContent.defaultProps = {
    rightContent: null,
    bottomContent: null
};
DesktopMegaMenuContent.propTypes = {
    rightContent: (prop_types_default()).node,
    bottomContent: (prop_types_default()).node,
    children: (prop_types_default()).node.isRequired
};

;// CONCATENATED MODULE: ./src/view/DesktopMegaMenu/DesktopMenuItems.js


function DesktopMenuItems(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "grid w-full grid-cols-2 gap-10 pb-4 pr-2",
        children: children
    });
};
DesktopMenuItems.defaultProps = {};
DesktopMenuItems.propTypes = {
    children: (prop_types_default()).node.isRequired
};

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/view/DesktopMegaMenu/DesktopMenuItem.js




function DesktopMenuItem(param) {
    var title = param.title, description = param.description, icon = param.icon, url = param.url, onItemClick = param.onItemClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        onClick: onItemClick,
        className: "flex items-start space-x-3",
        href: url,
        children: function(param) {
            var isHovering = param.isHovering;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center h-7",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: (0,clsx_m/* default */.Z)("h-6 w-6 transition duration-300 ease-in-out", isHovering === true && "text-green-500", isHovering === false && "text-gray-300"),
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            children: icon
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col flex-1 space-y-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                className: "flex items-center space-x-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)("text-lg font-semibold leading-7", isHovering === true && "text-gray-700", isHovering === false && "text-gray-900"),
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-4 overflow-hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            className: (0,clsx_m/* default */.Z)("h-4 w-4 transform text-gray-500 transition duration-500 ease-in-out", isHovering === true && "translate-x-0 opacity-100", isHovering === false && "-translate-x-2 opacity-0"),
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 20 20",
                                            fill: "currentColor",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                                                clipRule: "evenodd"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)("text-sm transition duration-300 ease-in-out", isHovering === true && "text-gray-800", isHovering === false && "text-gray-500"),
                                children: description
                            })
                        ]
                    })
                ]
            });
        }
    });
};
DesktopMenuItem.defaultProps = {
    onItemClick: function() {
        return null;
    }
};
DesktopMenuItem.propTypes = {
    title: (prop_types_default()).string.isRequired,
    description: (prop_types_default()).string.isRequired,
    icon: (prop_types_default()).node.isRequired,
    url: (prop_types_default()).string.isRequired,
    onItemClick: (prop_types_default()).func
};

;// CONCATENATED MODULE: ./src/view/DesktopMegaMenu/MenuAboutCompany.js






function MenuAboutCompany(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMegaMenuContent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopMenuItems, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Qui\xe9nes s\xf3mos",
                    description: "Conoce un poco m\xe1s sobre nosotros, nuestra misi\xf3n y nuestra visi\xf3n.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z",
                            clipRule: "evenodd"
                        })
                    }),
                    url: "/nosotros"
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Consultor\xeda y entrenamiento",
                    description: "Proveemos capacitaciones y entrenamientos a los equipos en tu organizaci\xf3n.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z",
                            clipRule: "evenodd"
                        })
                    }),
                    url: "/consultoria-y-entrenamiento"
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Clientes",
                    description: "Contamos con la confianza de empresas e instituciones reconocidas.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z",
                            clipRule: "evenodd"
                        })
                    }),
                    url: "/clientes"
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Cont\xe1ctenos",
                    description: "Mantengamos el contacto para trabajar juntos en su proyecto.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                            })
                        ]
                    }),
                    url: "/contacto"
                }, props))
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/view/DesktopMegaMenu/MenuPartners.js






function MenuPartners(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMegaMenuContent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopMenuItems, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Red de socios",
                    description: "Conozca a las organizaciones autorizadas que pertenecen a nuestra red.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                        })
                    }),
                    url: "/socios"
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Portal de socios",
                    description: "Acceda al portal exclusivo para nuestra red de socios y entrenadores.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z",
                            clipRule: "evenodd"
                        })
                    }),
                    url: "https://socios.aibes.org/"
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Programa de socios",
                    description: "Trabajemos juntos para acelerar el impacto en la adopci\xf3n de la cultura \xe1gil de nuestros clientes.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z",
                            clipRule: "evenodd"
                        })
                    }),
                    url: "https://socios.aibes.org/"
                }, props))
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/view/DesktopMegaMenu/MenuTraining.js






function MenuTraining(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMegaMenuContent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopMenuItems, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Informaci\xf3n de cursos",
                    description: "Tipos de cursos de entrenamiento que realizamos con la m\xe1s alta calidad.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"
                        })
                    }),
                    url: "/entrenamientos"
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Entrenadores",
                    description: "Conoce a los entrenadores que forman parte de nuestra comunidad.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
                        })
                    }),
                    url: "/entrenadores"
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Formaci\xf3n de entrenadores",
                    description: "S\xe9 parte del movimiento \xe1gil y garantiza la correcta adopci\xf3n de Scrum.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
                            clipRule: "evenodd"
                        })
                    }),
                    url: "/formacion-de-entrenadores-scrum"
                }, props))
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/view/DesktopMegaMenu/MenuCommunity.js






function MenuCommunity_MenuTraining(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMegaMenuContent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopMenuItems, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Blog",
                    description: "Lecturas sobre buenas pr\xe1cticas, m\xe9todos y experiencias \xe1giles.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                d: "M2 5a2 2 0 012-2h8a2 2 0 012 2v10a2 2 0 002 2H4a2 2 0 01-2-2V5zm3 1h6v4H5V6zm6 6H5v2h6v-2z",
                                clipRule: "evenodd"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M15 7h1a2 2 0 012 2v5.5a1.5 1.5 0 01-3 0V7z"
                            })
                        ]
                    }),
                    url: "/blog"
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Eventos",
                    description: "Participa en los eventos organizados por nuestra comunidad.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z",
                            clipRule: "evenodd"
                        })
                    }),
                    url: "/eventos"
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Validaci\xf3n de certificaciones",
                    description: "Accede a la herramienta de validaci\xf3n de certificaciones.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                            clipRule: "evenodd"
                        })
                    }),
                    url: "/validar-certificacion"
                }, props))
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/view/DesktopMegaMenu/MenuResources.js






function MenuResources(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMegaMenuContent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopMenuItems, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Libros",
                    description: "Descarga libros de autores de nuestra comunidad y otros autores destacados.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z"
                        })
                    }),
                    url: "/recursos/libros"
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Ex\xe1menes de pr\xe1ctica",
                    description: "Mide tus conocimientos b\xe1sicos de Scrum con nuestros ex\xe1menes de pr\xe1ctica.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z",
                            clipRule: "evenodd"
                        })
                    }),
                    url: "/examenes-de-practica"
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Materiales de Scrum",
                    description: "Descubre qu\xe9 es el m\xe9todo Scrum a trav\xe9s de estos materiales sencillos y pr\xe1cticos.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1z",
                            clipRule: "evenodd"
                        })
                    }),
                    url: "/recursos/materiales"
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMenuItem, (0,_object_spread/* default */.Z)({
                    title: "Uso de la marca",
                    description: "Recursos sobre los elementos fundamentales de nuestra marca.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M4 2a2 2 0 00-2 2v11a3 3 0 106 0V4a2 2 0 00-2-2H4zm1 14a1 1 0 100-2 1 1 0 000 2zm5-1.757l4.9-4.9a2 2 0 000-2.828L13.485 5.1a2 2 0 00-2.828 0L10 5.757v8.486zM16 18H9.071l6-6H16a2 2 0 012 2v2a2 2 0 01-2 2z",
                            clipRule: "evenodd"
                        })
                    }),
                    url: "https://marca.aibes.org/"
                }, props))
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/view/DesktopMegaMenu/DesktopMegaMenu.js









function DesktopMegaMenu(param) {
    var labelledby = param.labelledby, itemSlug = param.itemSlug, isHover = param.isHover, onMenuHover = param.onMenuHover, onMenuClick = param.onMenuClick;
    var isAboutActive = itemSlug === "about" && isHover;
    var isPartnersActive = itemSlug === "partners" && isHover;
    var isTrainingActive = itemSlug === "training" && isHover;
    var isCommunityActive = itemSlug === "community" && isHover;
    var isResourcesActive = itemSlug === "resources" && isHover;
    var isActive = itemSlug !== null && (isAboutActive || isPartnersActive || isTrainingActive || isCommunityActive || isResourcesActive);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "absolute top-0 left-0 right-0 z-40 w-full mt-20 bg-white shadow-xl focus:outline-none",
        tabIndex: "-1",
        children: [
            isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 z-50 w-full h-px bg-gray-600 opacity-10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMegaMenuContainer, {
                        isActive: isAboutActive,
                        onMenuHover: onMenuHover,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuAboutCompany, {
                            onItemClick: onMenuClick
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMegaMenuContainer, {
                        isActive: isPartnersActive,
                        onMenuHover: onMenuHover,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuPartners, {
                            onItemClick: onMenuClick
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMegaMenuContainer, {
                        isActive: isTrainingActive,
                        onMenuHover: onMenuHover,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuTraining, {
                            onItemClick: onMenuClick
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMegaMenuContainer, {
                        isActive: isCommunityActive,
                        onMenuHover: onMenuHover,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuCommunity_MenuTraining, {
                            onItemClick: onMenuClick
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopMegaMenuContainer, {
                        isActive: isResourcesActive,
                        onMenuHover: onMenuHover,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuResources, {
                            onItemClick: onMenuClick
                        })
                    })
                ]
            })
        ]
    });
};
DesktopMegaMenu.defaultProps = {
    labelledby: "menu",
    itemSlug: null,
    isHover: false,
    isShown: true,
    onMenuHover: function() {
        return null;
    },
    onMenuClick: function() {
        return null;
    }
};
DesktopMegaMenu.propTypes = {
    labelledby: (prop_types_default()).string,
    itemSlug: prop_types_default().oneOf([
        "about",
        "partners",
        "training",
        "community",
        "resources", 
    ]),
    isHover: (prop_types_default()).bool,
    isShown: (prop_types_default()).bool,
    onMenuHover: (prop_types_default()).func,
    onMenuClick: (prop_types_default()).func
};

;// CONCATENATED MODULE: ./src/view/DesktopMegaMenu/index.js

/* harmony default export */ var view_DesktopMegaMenu = (DesktopMegaMenu);


/***/ })

}]);